import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import React, { useRef } from 'react';
import { useSelector } from 'react-redux';

import Pilot from './Pilot';
import Robot from './Robot';

import OlMap from '@/helpers/OlMap';

const MapMapper = ({ data: robot }) => {
  const robotColor = useRef(robot.color);
  const droneOsd = useSelector((state) => state.telemetry[robot.id].droneOsd);
  const controlPayloads = useSelector((state) => state.telemetry[robot.id].controlPayloads);

  useUpdateEffect(() => {
    const { latitude: lat, longitude: lng } = droneOsd;

    OlMap.addHomePath(robot.id, { lat, lng });
    OlMap.addGotoPath(robot.id, { lat, lng }, robotColor.current);
  }, [droneOsd]);

  useUpdateEffect(() => {
    const { home_latitude: lat, home_longitude: lng } = controlPayloads;

    OlMap.addHomeMarker(robot.id, { lat, lng }, robotColor.current);
  }, [controlPayloads]);

  useUpdateEffect(() => {
    robotColor.current = robot.color;
    OlMap.changeColor(robot.id, robotColor.current);
  }, [robot.color]);

  return (
    <>
      <Robot data={robot} />
      <Pilot data={robot} />
    </>
  );
};

export default MapMapper;
